export enum ELexiconMaterialEvent {
    DISPLAY_INFORMATION = 'lexiconMaterial:displayInformation',
    INIT = 'lexiconMaterial:init'
}
